define('router',['require','exports','module','bootstrap','select2','jquery','backbone','views/LayoutWithSidebarView','views/LayoutView','env','i18n','modules/signup/index','modules/products/index','modules/private/index','modules/accounts/index','modules/payments/index','modules/integrations/index','react','modules/private/view-mdfooter'],function (require, exports, module) {
  "use strict";

  require("bootstrap");
  require("select2");

  var $ = require("jquery"),
    Backbone = require("backbone"),
    LayoutWithSidebar = require("views/LayoutWithSidebarView"),
    Layout = require("views/LayoutView"),
    Config = require("env"),
    i18n = require("i18n"),
    Signup = require("modules/signup/index"),
    Products = require("modules/products/index"),
    Private = require("modules/private/index"),
    Accounts = require("modules/accounts/index"),
    Payments = require("modules/payments/index"),
    Integrations = require("modules/integrations/index"),
    React = require("react"),
    MDFooterJS = require("modules/private/view-mdfooter");

  module.exports = Backbone.Router.extend({
    LOGIN_PAGE_CLASS: "login__page",
    REMINDER_PASS_PAGE_CLASS: "reminder-pass__page",
    generalLayout: null,

    initGeneralLayout: function () {
      this.generalLayout = new Layout();
      this.generalLayout.render();

      new MDFooterJS({ el: "#footer" }).render();
    },

    initGeneralLayoutWithSidebar: function () {
      this.generalLayout = new LayoutWithSidebar();
      this.generalLayout.render();

      new MDFooterJS({ el: "#footer" }).render();
    },

    initialize: function () {
      this.initGeneralLayoutWithSidebar();

      // init Accounts route!
      Accounts.init();
      Payments.init();
      Integrations.init();
    },

    routes: {
      "(origin/:origin)(/)(service/:service)(/)(lang/:lang)":
        "redirectRegister",
      "activation(/)(service/:service)(/)(lang/:lang)(/)(company/:company)(redirect/:redirect)":
        "activation",
      products: "start",
      "start(/)(group/:group)(/)(company/:company)": "start",
      forget: "forget",
      "resetpassword(/ticket/:ticket)": "resetpassword",
      "resetpassword(/ticket/:ticket)/secure": "resetpassword",
      "resetpassword(/ticket/:ticket)/force": "resetpassword",
      "resetcredentials(/ticket/:ticket)": "resetpassword",
      "resetcredentials(/ticket/:ticket)/secure": "resetpassword",
      "resetcredentials(/ticket/:ticket)/force": "resetpassword",
      surveycompleted: "start",
    },

    redirectRegister: function (origin, service, lang) {
      lang = lang || $.i18n.lng();
      location.href = Config.registerUrl[lang] || Config.registerUrl.es;
    },

    forget: function () {
      this.initGeneralLayout();

      this.generalLayout.$el.addClass(this.LOGIN_PAGE_CLASS);
      this.generalLayout.$el.addClass(this.REMINDER_PASS_PAGE_CLASS);

      var lang = $.i18n.detectLanguage();
      var view = new Signup.Views.Forget({
        el: "#content",
        model: new Signup.Models.ResetPassword({
          lang: lang,
        }),
      });
      view.render();
    },

    resetpassword: function (ticket) {
      this.initGeneralLayout();
      this.generalLayout.$el.addClass(this.LOGIN_PAGE_CLASS);

      var model, view;

      model = new Signup.Models.ResetPassword({
        _ticket: ticket,
      });

      view = new Signup.Views.ResetPassword({
        el: "#content",
        model: model,
      });

      model.fetch();
      view.render();
    },

    activation: function (service, lang, company, redirect) {
      this.initGeneralLayout();
      if (lang) {
        i18n.setLng(lang);
      }

      var activationModel = new Products.Models.Activation();

      new Products.Views.Activation({
        el: "#content",
        serviceName: service,
        model: activationModel,
      });

      activationModel.save(
        {
          serviceName: service,
          company_id: company,
        },
        {
          success: function (model) {
            var redirectURL;
            if (redirect && redirect !== "null") {
              redirectURL = "https:\\\\" + redirect;
            } else {
              redirectURL = model.get("url");
            }

            document.location = redirectURL;
          },
        }
      );
    },

    start: function (groupId, companyId, deleteNotice) {
      location.href = Config.mdirectorPrivateUrl;
    },
  });
});

